import { FormControl, FormControlLabel, FormLabel, InputLabel, Menu, MenuItem, Radio, RadioGroup, Select, TextField } from '@mui/material'
import React, { useState } from 'react'
import { AiOutlineDelete } from 'react-icons/ai'
import { RiRefund2Line } from 'react-icons/ri'
import { Privileges } from '../../../util/PrivilegeConstants'
import { CiMenuKebab } from 'react-icons/ci'
import styles from '../../../styles/modules/ChildProfile.module.css';
import { MdOutlineEdit } from 'react-icons/md'
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog'
import CustomAlertDialog from '../../CustomComponents/CustomAlertDialog'
import { useDispatch } from 'react-redux'
import { rootAction } from '../../../redux/reducer/rootReducer'
import { PaymentAPI } from '../../../api/PaymentAPI'

const PlayerFeeHistoryBody = ({ eventId,isPlayer,feeHistory,setFeeHistory,selectedClub, fee, privileges, playerId, offlinePaymentMethod, setIsLoading, setIsUpdate }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [openPopup, setOpenPopup] = useState(false)
    const [popupData, setPopupData] = useState({ isOpen: false });
    const [refundAmount, setRefundAmount] = useState('');
    const [refundReason, setRefundReason] = useState('');
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [status, setStatus] = useState({ id: '', statusName: '' });
      const dispatch = useDispatch();
    const radioStyle = {
        '&.Mui-checked': {
            color: 'var(--hoverColorBold)', // checked color
        },
        '&.Mui-checked ~ .MuiFormControlLabel-label': {
            color: 'var(--hoverColorBold)',
        },
    }
    const handleRefundAPI = async () => {
        try {
            setPopupData({isOpen:false});
            const refundInfo = {
                clubId: selectedClub.clubId,
                paymentIntentId: fee.stripePaymentId,
                reason: refundReason,
                amount: refundAmount,
                paymentHistoryId: fee.id
            }
            setIsLoading(true)
            const response = await PaymentAPI.postCreateRefundForRoster(refundInfo);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: response.Data }));
            setIsUpdate(true);
        } catch (error) {
            console.error(error);
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Please contact customer support' }));
        } finally {
            setIsLoading(false);
            
        }
    }
    const handleUpdatePaymentHistory = async() => {
       try{
           setIsLoading(true);
        await PaymentAPI.putUpdateOfflinePaymentHistory({
            id: fee.id,
            paymentMethodId: paymentMethod,
            eventId: eventId,
            playerId: playerId,
            isPlayer: isPlayer,
            status: status.statusName === '' ? fee.status : status.statusName
        });
      
           setFeeHistory(feeHistory.map((h)=>h.id===fee.id ? {...h,status:status.statusName,paymentMethodId: paymentMethod} : h))

       }catch(error){
           console.log(error);
       }finally{
           setIsLoading(false);
       }
    };

    return (
        <>
            <tr key={fee?.id}>
                <td align='left'>{fee.transactionId}</td>
                <td align='left'>{fee.paymentFor}</td>
                {fee?.status === 'succeeded' &&
                    <td align='left' className={styles['guardian_status']} >
                        <span className={styles['guardian_status_active']}></span> Succeeded
                    </td>}
                {fee?.status === 'pending' &&
                    <td align='left' className={styles['guardian_status']} >
                        <span className={styles['guardian_status_pending']}></span> Pending
                    </td>}
                {fee?.status === 'refunded' &&
                    <td align='left' className={styles['guardian_status']} >
                        <span className={styles['guardian_status_refund']}></span> Refunded
                    </td>}
                {fee?.status === 'canceled' &&
                    <td align='left' className={styles['guardian_status']} >
                        <span className={styles['guardian_status_refund']}></span> Canceled
                    </td>}
                <td align='left'>${fee.amount}</td>
                <td align='left'>${fee.netAmount}</td>
                <td align='left'>${fee.processingFee}</td>
                <td align='left'>${fee.refundedAmount}</td>
                {(privileges?.MANAGE_ROSTER?.includes(Privileges.MODIFY) || privileges?.MANAGE_ROSTER?.includes(Privileges.REFUND)) &&
                    <td align='center'>
                        {(privileges?.MANAGE_ROSTER?.includes(Privileges.MODIFY) || privileges?.MANAGE_ROSTER?.includes(Privileges.REFUND)) &&
                            <CiMenuKebab onClick={(e) => setAnchorEl(e.currentTarget)} className='roster_player_delete_icon' />}
                    </td>}
            </tr>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {privileges?.MANAGE_ROSTER?.includes(Privileges.MODIFY) &&
                    <MenuItem onClick={() => {
                        setStatus({ id: fee.id, statusName: fee.status })
                        setOpenPopup(true)
                        setAnchorEl(null)
                    }}><MdOutlineEdit className='roster_player_delete_icon' />Edit</MenuItem>}
                {(privileges?.MANAGE_ROSTER?.includes(Privileges.REFUND) && fee?.stripePaymentId) &&
                    <MenuItem disabled={!fee?.stripePaymentId || (fee.status === 'refunded' && Number(fee.netAmount) === 0)} onClick={() => {
                        setPopupData({ isOpen: true })
                        setAnchorEl(null)
                        setRefundAmount((Number(fee.netAmount)).toFixed(2));
                    }}><RiRefund2Line className='roster_player_delete_icon' />Refund</MenuItem>}
            </Menu>
            <CustomDialog
                isOpen={popupData.isOpen}
                onClose={() => setPopupData({ isOpen: false })}
                onCancel={() => setPopupData({ isOpen: false })}
                onSubmit={handleRefundAPI}
                submitBtnName='Refund'
                title="Refund details"
            >
                <form className="reservation-refund-form">
                    <p>Refunds take 5-10 days to appear on a customer's statement. Fees for the original payment won't be returned, but there are no additional fees for the refund. </p>
                    <div className="reservation-refund-input">
                        <TextField
                            fullWidth
                            className="reservation-amount-text-input"
                            variant="outlined"
                            name="firstName"
                            value={refundAmount || ''}
                            onChange={(e)=>setRefundAmount(e.target.value)}
                            label="Amount *" />
                        <FormControl
                            fullWidth
                            data-testid="game-dropdown" className='calender-game-dropdown'
                        >
                            <InputLabel id="demo-simple-select-autowidth-label">Reason</InputLabel>
                            <Select
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                value={refundReason || ''}
                                onChange={(e) => setRefundReason(e.target.value)}
                                label="Reason"
                            >
                                <MenuItem value="REQUESTED_BY_CUSTOMER">Request from customer</MenuItem>
                                <MenuItem value="FRAUDULENT">Fraudulent</MenuItem>
                                <MenuItem value="DUPLICATE">Duplicate</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </form>
            </CustomDialog>
            <CustomDialog
                title="Update details"
                isOpen={openPopup}
                onClose={() => setOpenPopup(false)}
                onCancel={() => {
                    setOpenPopup(false);
                    setStatus({});
                }}
                submitBtnName='Save'
                onSubmit={() => {
                    handleUpdatePaymentHistory();
                    setOpenPopup(false);
                }}
            >
                <div className='sm_edit_status_in_roster'>
                    <FormControl data-testid="game-dropdown"
                        className='sm_roster_select_season_input'
                        fullWidth>
                        <InputLabel id="demo-simple-select-autowidth-label">Status</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={status.statusName}
                            onChange={(e) => setStatus({ ...status, statusName: e.target.value })}
                            name='relation'
                            label="Status"
                        >

                            <MenuItem value="succeeded">
                                Succeeded
                            </MenuItem>
                            <MenuItem value="pending">
                                Pending
                            </MenuItem>
                            <MenuItem value="refunded">
                                Refunded
                            </MenuItem>
                            <MenuItem value="canceled">
                                Canceled
                            </MenuItem>
                        </Select>
                    </FormControl>

                    {!fee?.stripePaymentId &&
                        <FormControl
                            fullWidth>
                            <FormLabel sx={
                                {
                                    "&.Mui-focused": {
                                        color: "var(--hoverColorBold)",   // active/focused color
                                    },
                                }
                            } id="demo-radio-buttons-group-label">Payment Method</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-radio-buttons-group-label"
                                onChange={(event) => setPaymentMethod(event.target.value)}
                                value={paymentMethod || fee.paymentMethodId}

                            >
                                {offlinePaymentMethod?.map((p, idx) =>
                                    <FormControlLabel key={idx} value={p?.id} control={
                                        <Radio
                                            sx={radioStyle} />} label={p?.paymentMethodName} />
                                )}

                            </RadioGroup>
                        </FormControl>}
                </div>
            </CustomDialog>
        </>
    )
}

export default PlayerFeeHistoryBody